import onboardReducer from './reducers';
import * as allOnboardActions from './actions';

export { default as onboardOperations } from './operations';
export { default as onboardTypes } from './types';
export const onboardActions = allOnboardActions;

export default onboardReducer;
